import { bluePaletteDark, grayPaletteDark } from '../../themes/dark-colors';

export const radioDarkTheme = {
  focusColor: bluePaletteDark[300],
  border: {
    checked: bluePaletteDark[700],
    default: grayPaletteDark[400],
    disabled: grayPaletteDark[400],
  },
  background: {
    checked: bluePaletteDark[700],
    default: grayPaletteDark[0],
    disabled: grayPaletteDark[300],
  },
  innerCircle: {
    checked: grayPaletteDark[0],
    default: grayPaletteDark[0],
    disabled: grayPaletteDark[300],
  },
};
